import { InjectionToken } from '@angular/core';

export const REACH_API_COMMON_HEADERS = new InjectionToken<Record<string, string>>(
	'REACH_API_COMMON_HEADERS',
	{
		factory: () => ({}),
	}
);
